/* Dependencies */
import { SortBy } from '../../CoffeePicker.model';

type SortByValues =
  | 'title_asc'
  | 'title_desc'
  | 'newest'
  | 'oldest'
  | 'price_high'
  | 'price_low';

/**
 * Match sort to url parm.
 * @param sort - Current sort.
 */
export const matchSortFromType = (sort: SortBy): SortByValues => {
  switch (sort) {
    case 'Alphabetically, A-Z': {
      return 'title_asc';
    }
    case 'Alphabetically, Z-A': {
      return 'title_desc';
    }
    case 'Date, new to old': {
      return 'newest';
    }
    case 'Date, old to new': {
      return 'oldest';
    }
    case 'Price, high to low': {
      return 'price_high';
    }
    case 'Price, low to high': {
      return 'price_low';
    }
    default: {
      return 'title_asc';
    }
  }
};

/**
 * Match sort from url parm.
 * @param sort - Current sort.
 */
export const matchSortFromUrl = (sort: SortByValues): SortBy => {
  switch (sort) {
    case 'title_asc': {
      return 'Alphabetically, A-Z';
    }
    case 'title_desc': {
      return 'Alphabetically, Z-A';
    }
    case 'newest': {
      return 'Date, new to old';
    }
    case 'oldest': {
      return 'Date, old to new';
    }
    case 'price_high': {
      return 'Price, high to low';
    }
    case 'price_low': {
      return 'Price, low to high';
    }
    default: {
      return 'Alphabetically, A-Z';
    }
  }
};
